var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarKeri(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "avatar-keri_svg__a",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "avatar-keri_svg__e",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "avatar-keri_svg__c",
    d: "M0 .182h43.456v43.046H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar-keri_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar-keri_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0E3E4",
    xlinkHref: "#avatar-keri_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#avatar-keri_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.683 5.727c-7.196 0-13.03 5.834-13.03 13.03 0 0-5.675 18.888 0 21.475 5.675 2.586 13.03.646 13.03.646s9.647 2.345 13.029-.646c3.382-2.991 0-21.475 0-21.475 0-7.196-5.834-13.03-13.03-13.03",
    fill: "#463012"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 41.792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar-keri_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar-keri_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.797 43.228H41.66l1.748-27.107c.073-1.133.07-2.27-.044-3.4C42.481 4 31.584.183 26.18.183h-8.901C11.872.182.975 4 .093 12.722a20.597 20.597 0 00-.044 3.399l1.748 27.107z",
    fill: "#F37942",
    mask: "url(#avatar-keri_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.913 23.853c-1.056.609-.717 1.752-1.586 2.099a4.902 4.902 0 00-.469-1.973c-1.293-2.768-5.015-4.456-8.024-5.17-3.668-.868-6.177-4.632-6.177-4.632s-1.603 1.347-2.98 3.96c-1.233 2.34-1.838 4.96-1.838 7.605v.616s-2.34-4.516-2.34-.196 2.34 3.44 2.34 3.44a9.762 9.762 0 005.31 8.69l-.052 1.608c-.032.977-.466 1.919-1.246 2.507-.826.622-1.313 1.746-1.313 3.765 0 5.144 3.156 9.313 7.048 9.313s7.047-4.17 7.047-9.313c0-2.019-.486-3.143-1.312-3.765-.78-.588-1.214-1.53-1.246-2.507l-.052-1.59a9.764 9.764 0 005.323-8.058 2.174 2.174 0 001.966-1.82l.39-2.413c.131-.817-.166-1.651-.79-2.166",
    fill: "#FCDCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.913 23.853c-1.056.609-.717 1.752-1.586 2.099a4.902 4.902 0 00-.469-1.973 6.077 6.077 0 00-.984-1.467c.002 1.195.013 2.143.013 3.11 0 5.015-1.81 13.158-8.415 13.701-2.249.185-3.662-.612-4.323-1.032l-.052 1.609a3.505 3.505 0 01-.11.758c1.022.88 4.627 3.433 9.367.492a3.473 3.473 0 01-.28-1.25l-.05-1.59a9.764 9.764 0 005.322-8.058 2.174 2.174 0 001.966-1.82l.39-2.413c.131-.817-.166-1.651-.79-2.166M27.042 16.783c2.537 3.489 6.6 2.16 11.327 4.407-1.644-1.164-3.72-1.95-5.535-2.38-3.668-.869-6.177-4.633-6.177-4.633s-1.603 1.347-2.98 3.96a16.105 16.105 0 00-1.779 6.185c.75-2.782 2.247-6.326 5.144-7.54",
    fill: "#F1A29D"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  }))));
}

export default SvgAvatarKeri;